import {
    get,
    post,
    put,
    destroy
} from 'app/services/ApiService';

import {
    BILLINGS_URL,
    BILLING_URL,
    SEARCH_BILLINGS_URL,
    SEARCH_ACCOUNT_BILLINGS_URL,
    SEARCH_ACCOUNT_PRICINGS_URL,
    SEARCH_BILLING_EXPORT_SCHEDULE_URL,
    ACCOUNT_BILLINGS_URL,
    ACCOUNT_BILLING_URL,
    ACCOUNT_PRICINGS_URL,
    ACCOUNT_PRICING_URL,
    BILLING_REPORT_URL,
    BILLING_EXPORT_SCHEDULES_URL,
    BILLING_EXPORT_SCHEDULE_URL
} from 'app/utils/Constants';

export const getBillings = async params => {
    return await post(SEARCH_BILLINGS_URL(), params);
}

export const createBilling = async params => {
    return await post(BILLINGS_URL(), params);
}

export const updateBilling = async (id, params) => {
    return await put(BILLING_URL(id), params);
}

export const destroyBilling = async id => {
    return await destroy(BILLING_URL(id));
}

export const getAccountBilling = async params => {
    return await post(SEARCH_ACCOUNT_BILLINGS_URL(), params);
}

export const createAccountBilling = async params => {
    return await post(ACCOUNT_BILLINGS_URL(), params);
}

export const updateAccountBilling = async (id, params) => {
    return await put(ACCOUNT_BILLING_URL(id), params);
}

export const destroyAccountBilling = async id => {
    return await destroy(ACCOUNT_BILLING_URL(id));
}

export const getAccountPricings = async params => {
    return await post(SEARCH_ACCOUNT_PRICINGS_URL(), params);
}

export const createAccountPricing = async params => {
    return await post(ACCOUNT_PRICINGS_URL(), params);
}

export const updateAccountPricing = async (id, params) => {
    return await put(ACCOUNT_PRICING_URL(id), params);
}

export const destroyAccountPricing = async id => {
    return await destroy(ACCOUNT_PRICING_URL(id));
}

export const generateBillingReport = async (params) => {
    return await post(BILLING_REPORT_URL(), params);
}

export const getBillingExportScheds = async (params) => {
    return await post(SEARCH_BILLING_EXPORT_SCHEDULE_URL(), params);
}

export const createBillingExportSched = async params => {
    return await post(BILLING_EXPORT_SCHEDULES_URL(), params);
}

export const updateBillingExportSched = async (id, params) => {
    return await put(BILLING_EXPORT_SCHEDULE_URL(id), params);
}

export const destroyBillingExportSched = async (id) => {
    return await destroy(BILLING_EXPORT_SCHEDULE_URL(id));
}
